export class PricingResponse {
  price: number;
}